// src/api.router.config.js
const LOGISTIC_URL = "https://logistic.tydal-dev.cloud/api/v1"; //"http://127.0.0.1:9000/api/v1";
const GPS_URL = "https://gps.tydal-dev.cloud";

const endpoints = {
  baseUrl: LOGISTIC_URL,
  gpsUrl: GPS_URL,

  auth: {
    login: `${LOGISTIC_URL}/auth`,
    login2: `${LOGISTIC_URL}/auth/generate-token`,
    refresh: `${LOGISTIC_URL}/auth/refresh`,
    me: `${LOGISTIC_URL}/auth/me`,
    logout: `${LOGISTIC_URL}/auth/logout`,
    app_code: `${LOGISTIC_URL}/auth/app-code`,
  },

  agences: {
    list: `${LOGISTIC_URL}/agences`,
    single: (id) => `${LOGISTIC_URL}/agences/${id}`,
  },

  chauffeurs: {
    list: `${LOGISTIC_URL}/employees/chauffeurs`,
    single: (id) => `${LOGISTIC_URL}/employees/chauffeurs/${id}`,
  },

  convoyeurs: {
    list: `${LOGISTIC_URL}/employees/convoyeurs`,
    single: (id) => `${LOGISTIC_URL}/employees/convoyeurs/${id}`,
  },

  vehicules: {
    list: `${LOGISTIC_URL}/vehicules`,
    single: (id) => `${LOGISTIC_URL}/vehicules/${id}`,
  },

  navettes: {
    create: `${LOGISTIC_URL}/navettes/create`,
    update: (id) => `${LOGISTIC_URL}/navettes/update/${id}`,
    soft_delete: (id) => `${LOGISTIC_URL}/navettes/${id}/soft-delete`,
    delete: (id) => `${LOGISTIC_URL}/navettes/${id}/delete`,
    restore: (id) => `${LOGISTIC_URL}/navettes/${id}/restore`,
    list: `${LOGISTIC_URL}/navettes/list`,
    paged_list: `${LOGISTIC_URL}/navettes`,
    by_id: (id) => `${LOGISTIC_URL}/navettes/${id}`,
  },

  missions: {
    create: `${LOGISTIC_URL}/missions`,
    update_chauffeur: (id) => `${LOGISTIC_URL}/missions/${id}/chauffeur`,
    update_convoyeur: (id) => `${LOGISTIC_URL}/missions/${id}/convoyeur`,
    update_vehicule: (id) => `${LOGISTIC_URL}/missions/${id}/vehicule`,
    update_estimation: (id) => `${LOGISTIC_URL}/missions/${id}/estimation`,
    delete_etape: (id) => `${LOGISTIC_URL}/missions/${id}/delete-etape`, //id de l'etape à supprimer
    add_etape: (id) => `${LOGISTIC_URL}/missions/${id}/add-etape`,
    confirm: (id) => `${LOGISTIC_URL}/missions/${id}/confirm`,
    finish: (id) => `${LOGISTIC_URL}/missions/${id}/finish`,
    admin_finish: (id) => `${LOGISTIC_URL}/missions/admin/${id}/finish`,

    list_supervision: (params) =>
      `${LOGISTIC_URL}/missions/supervision/list?${params}`,
    list_admin: (params) => `${LOGISTIC_URL}/missions/admin?${params}`,
    list_agence: (params) => `${LOGISTIC_URL}/missions/agence?${params}`,
    list_convoyeur: (params) => `${LOGISTIC_URL}/missions/convoyeur?${params}`,
    single_supervision: (id) => `${LOGISTIC_URL}/missions/supervision/${id}`,
    single_admin: (id) => `${LOGISTIC_URL}/missions/admin/${id}`,
    single_agence: (id) => `${LOGISTIC_URL}/missions/agence/${id}`,
    single_convoyeur: (id) => `${LOGISTIC_URL}/missions/convoyeur/${id}`,
    single_print: (id) => `${LOGISTIC_URL}/missions/print/${id}`,
    operations: (matricule, convoyeur) =>
      `${LOGISTIC_URL}/missions/operations/${matricule}/${convoyeur}`,
    operations_convoyeur: `${LOGISTIC_URL}/missions/operations/convoyeur`,
    soft_delete: (id) => `${LOGISTIC_URL}/missions/${id}/soft-delete`,
    delete: (id) => `${LOGISTIC_URL}/missions/${id}/delete`,
    restore: (id) => `${LOGISTIC_URL}/missions/${id}/restore`,
  },

  parcels: {
    expedite: `${LOGISTIC_URL}/parcels/expedite`, // à supprimer plus tard
    receive: `${LOGISTIC_URL}/parcels/receive`, // à supprimer plus tard
    add_lost: `${LOGISTIC_URL}/parcels/lost`,
    add_found: `${LOGISTIC_URL}/parcels/found`,
    summary: (etapeId) => `${LOGISTIC_URL}/parcels/${etapeId}/summary`,
    receptions: (etapeId) => `${LOGISTIC_URL}/parcels/${etapeId}/receptions`,
    expedition: `${LOGISTIC_URL}/parcels/expedition`,
    reception: `${LOGISTIC_URL}/parcels/reception`,
    history: (tracking) => `${LOGISTIC_URL}/parcels/${tracking}/history`,
    history_agence: (hubId, query = "") =>
      `${LOGISTIC_URL}/parcels/report-agence/${hubId}${query ? `?${query}` : ""}`,
    lost_found: `${LOGISTIC_URL}/parcels/lost-found`,
    reports: `${LOGISTIC_URL}/parcels/reports`,
  },

  etapes: {
    start: (missionId, etapeId) =>
      `${LOGISTIC_URL}/etapes/start/${missionId}/${etapeId}`,
    finish: (missionId, etapeId) =>
      `${LOGISTIC_URL}/etapes/finish/${missionId}/${etapeId}`,
    resume: (missionId, etapeId) =>
      `${LOGISTIC_URL}/etapes/resume/${missionId}/${etapeId}`,
  },

  pauses: {
    start: (missionId) => `${LOGISTIC_URL}/pauses/${missionId}/start`,
    end: (missionId) => `${LOGISTIC_URL}/pauses/${missionId}/end`,
    single_active: (missionId) => `${LOGISTIC_URL}/pauses/${missionId}/active`,
    list: (missionId) => `${LOGISTIC_URL}/pauses/${missionId}`,
  },

  stats: {
    // ----- Missions -----
    missions_global: (params = "") => {
      const q = params ? `?${params}` : "";
      return `${LOGISTIC_URL}/stats/missions/global${q}`;
    },

    missions_distance_duration: (params = "") => {
      const q = params ? `?${params}` : "";
      return `${LOGISTIC_URL}/stats/missions/distance-duration${q}`;
    },

    missions_performance: (params = "") => {
      const q = params ? `?${params}` : "";
      return `${LOGISTIC_URL}/stats/missions/performance${q}`;
    },

    // ----- Agences / Étapes -----
    agences_load: (params = "") => {
      const q = params ? `?${params}` : "";
      return `${LOGISTIC_URL}/stats/agences/load${q}`;
    },

    agences_steps_duration: (params = "") => {
      const q = params ? `?${params}` : "";
      return `${LOGISTIC_URL}/stats/agences/steps-duration${q}`;
    },

    // ----- Parcels -----
    parcels_status: (params = "") => {
      const q = params ? `?${params}` : "";
      return `${LOGISTIC_URL}/stats/parcels/status${q}`;
    },

    parcels_lost_found: (params = "") => {
      const q = params ? `?${params}` : "";
      return `${LOGISTIC_URL}/stats/parcels/lost-found${q}`;
    },

    parcels_transit_routes: (params = "") => {
      const q = params ? `?${params}` : "";
      return `${LOGISTIC_URL}/stats/parcels/transit-routes${q}`;
    },

    // ----- Pauses -----
    pauses: (params = "") => {
      const q = params ? `?${params}` : "";
      return `${LOGISTIC_URL}/stats/pauses${q}`;
    },

    // ----- Anomalies -----
    anomalies: (params = "") => {
      const q = params ? `?${params}` : "";
      return `${LOGISTIC_URL}/stats/anomalies${q}`;
    },
  },
};

export default endpoints;
